module.exports = __webpack_public_path__ + "media/Destiny And Heart.8f0607f4.mp3";